import { Chip, Grid2 } from '@mui/material';
import React from 'react';

export default function Pill({
  color = 'secondary',
  label = '',
  size = 'small',
  header = false,
}: {
  color?: 'primary' | 'secondary';
  label: string;
  size: 'medium' | 'small';
  header?: boolean;
}) {
  return (
    <Grid2
      alignItems="center"
      sx={{
        paddingLeft: {
          xs: header ? '20px' : '0px',
          sm: '0px',
        },
      }}
    >
      <Chip
        clickable={false}
        color={color}
        data-testid="pill-chip"
        label={label}
        size={size}
      />
    </Grid2>
  );
}
